<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Dashboard" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />

          <div class="card-with-tab mb-3">
            <div class="">
              <ul class="nav nav-pills">
                <li
                  v-for="tab in upperTabs"
                  v-bind:key="tab.link"
                  class="nav-item"
                >
                  <router-link
                    :to="tab.link"
                    :class="
                      `nav-link ${
                        tab.label == 'REKAPITULASI LAPORAN' ? 'active' : ''
                      }`
                    "
                    >{{ tab.label }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <LeftMenuRl active="rl5" />
            </div>
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-4">
                  <PageContentHeader
                    :data="dataRl"
                    :fromUrl="fromUrl || ''"
                    :fromTab="$route.query.fromTab || ''"
                  />
                </div>
                <div class="col-md-6">
                  <FormRow
                    :row="filters"
                    @handleChange="(e) => handleChange(e)"
                  />
                </div>
                <div class="col-md-2 pl-0">
                  <button class="btn btn-secondary btn-block" @click="apply">
                    Apply
                  </button>
                </div>
              </div>
              <div>
                <b-tabs content-class="mt-3">
                  <b-tab title="RL 5.1" active>
                    <div class="card" v-if="loaded1">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-9">
                            <h4 class="mt-2">
                              Formulir RL 5.1 Pengunjung Rumah Sakit
                            </h4>
                          </div>
                          <div class="col-md-3 pl-3">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl51"
                              worksheet="RL-5.1"
                              name="rekapitulasi_laporan_5_1"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl51"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl51,
                              rowHeaders: false,
                              colHeaders: false,
                              height: 'auto',
                              width: '100%',
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                    <Loading v-else />
                  </b-tab>
                  <b-tab title="RL 5.2">
                    <div class="card" v-if="loaded2">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-9">
                            <h4 class="mt-2">
                              Formulir RL 5.2 Kunjungan Rawat Jalan
                            </h4>
                          </div>
                          <div class="col-md-3 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl52"
                              worksheet="RL-5.2"
                              name="rekapitulasi_laporan_5_2"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl52"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl52,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                    <Loading v-else />
                  </b-tab>
                  <b-tab title="RL 5.3">
                    <div class="card" v-if="loaded3">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-9">
                            <h4 class="mt-2">
                              Formulir RL 5.3 Daftar 10 Besar Penyakit Rawat
                              Inap
                            </h4>
                          </div>
                          <div class="col-md-3 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl53"
                              worksheet="RL-5.3"
                              name="rekapitulasi_laporan_5_3"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl53"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl53,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                    <Loading v-else />
                  </b-tab>
                  <b-tab title="RL 5.4">
                    <div class="card" v-if="loaded4">
                      <div class="card-body">
                        <div class="row mb-4">
                          <div class="col-md-9">
                            <h4 class="mt-2">
                              Formulir RL 5.4 Daftar 10 Besar Penyakit Rawat
                              Jalan
                            </h4>
                          </div>
                          <div class="col-md-3 pl-5">
                            <download-excel
                              class="btn btn-default btn-primary btn-block"
                              :data="rl54"
                              worksheet="RL-5.4"
                              name="rekapitulasi_laporan_5_4"
                            >
                              Download Excel
                            </download-excel>
                          </div>
                        </div>
                        <div
                          style="height: auto; width: 100%; overflow: auto"
                          id="rl54"
                        >
                          <hot-table
                            :settings="{
                              licenseKey: 'non-commercial-and-evaluation',
                              data: rl54,
                              height: 'auto',
                              width: '100%',
                              rowHeaders: false,
                              colHeaders: false,
                            }"
                          ></hot-table>
                        </div>
                      </div>
                    </div>
                    <Loading v-else />
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import DoughnutChart from "@/components/DoughnutChart.js";
// import BarChart from "@/components/BarChart.js";
import HorizontalBarChart from "@/components/HorizontalBarChart.js";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import LeftMenuRl from "@/components/LeftMenuRl.vue";
import { ageInterval, getInputDate } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import { HotTable } from "@handsontable/vue";
import { registerAllModules } from "handsontable/registry";
import "handsontable/dist/handsontable.full.css";
registerAllModules();

import {
  data,
  dataRl5,
  tabs,
  filtersRl5,
  sort,
  upperTabs,
  formattedFirstDayOfYear,
  formattedToday,
} from "@/data/Dashboard.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "DashboardRl3",
  data: function() {
    return {
      fromUrl: "",
      plainUrl: "",
      loaded1: false,
      loaded2: false,
      loaded3: false,
      loaded4: false,
      data: data,
      dataHot: [
        ["", "Ford", "Volvo", "Toyota", "Honda"],
        ["2016", 10, 11, 12, 13],
        ["2017", 20, 11, 14, 13],
        ["2018", 30, 15, 12, 13],
      ],
      dataRl: dataRl5,
      upperTabs: upperTabs,
      LeftMenuRl: LeftMenuRl,
      filters: filtersRl5,
      formSet: {
        dari: formattedFirstDayOfYear,
        sampai: formattedToday,
      },
      rl51: [],
      rl52: [],
      rl53: [],
      rl54: [],
      combinedData: [],
    };
  },
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    LeftMenuRl,
    FormRow,
    HotTable,
    Loading,
  },
  methods: {
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
      //console.log(this.formSet);
      // await this.displayList();
      // this.$nextTick(() => {
      //   if (this.$refs.focusMe) {
      //     this.$refs.focusMe.focus();
      //   }
      // });
      // this.apply();
    },
    combineData: async function() {
      this.combinedData = [
        {
          data: [
            ...this.rl51.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 5.1 Kegiatan Pelayanan Rawat Inap",
        },
        {
          data: [
            ...this.rl52.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 5.2 Kegiatan Pelayanan Rawat Darurat",
        },
        {
          data: [
            ...this.rl53.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 5.3 Kegiatan Kesehatan Gigi dan Mulut",
        },
        {
          data: [
            ...this.rl54.map(function(item) {
              return { Judul: item.title, Data: String(item.content) };
            }),
          ],
          columns: [
            { label: "Judul", field: "Judul" },
            { label: "Data", field: "Data" },
          ],
          name: "Formulir RL 5.4 Kegiatan Kebidanan",
        },
      ];

      //console.log(this.combinedData);
    },
    displayData: async function(rl, endpoint, loadedStr) {
      this[loadedStr] = false;
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          Object.keys(result.data).forEach(function(key, index) {
            let content = "";
            if (!index) {
              rl.push({
                no: "No",
                title: "Jenis Kegiatan",
                content: "Jumlah",
              });
            }
            if (typeof result.data[key] !== "object") {
              content = result.data[key];
            }
            rl.push({
              no: index + 1,
              title: key
                .replace(/_/g, " ")
                .split(" ")
                .map((word) => word[0].toUpperCase() + word.slice(1))
                .join(" "),
              // key: key,
              content: content,
            });
            if (typeof result.data[key] === "object") {
              Object.keys(result.data[key]).forEach(function(innerKey) {
                let innerContent = "";
                if (typeof result.data[key][innerKey] !== "object") {
                  innerContent = result.data[key][innerKey];
                }
                rl.push({
                  title: innerKey
                    .replace(/_/g, " ")
                    .split(" ")
                    .map((word) => word[0].toUpperCase() + word.slice(1))
                    .join(" "),
                  key: innerKey,
                  content: innerContent,
                });
                if (typeof result.data[key][innerKey] === "object") {
                  Object.keys(result.data[key][innerKey]).forEach(function(
                    innerInnerKey
                  ) {
                    let innerInnerContent = "";
                    if (
                      typeof result.data[key][innerKey][innerInnerKey] !==
                      "object"
                    ) {
                      innerInnerContent =
                        result.data[key][innerKey][innerInnerKey];
                    }
                    rl.push({
                      title: innerInnerKey
                        .replace(/_/g, " ")
                        .split(" ")
                        .map((word) => word[0].toUpperCase() + word.slice(1))
                        .join(" "),
                      key: innerInnerKey,
                      content: innerInnerContent,
                    });
                  });
                }
              });
            }
            //console.log("------------------ displayData");
            //console.log(rl);
            //console.log("------------------ displayData");
          });
          ////console.log(self.formSet);
        } else {
          this.errors.push(result.status);
        }
        this[loadedStr] = true;
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
    },
    displayDataRl52: async function(rl, endpoint, blacklist, loadedStr) {
      this[loadedStr] = false;
      this.errors = [];
      let len = rl.length;
      for (var i = 0; i < len; i++) {
        rl.pop();
      }
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        console.log(result);
        if (result.status == "200") {
          result.data.forEach((item, index) => {
            if (!index) {
              rl.push({ no: "No" });
              Object.keys(item).forEach(function(key) {
                if (typeof item[key] == "object") {
                  Object.keys(item[key]).forEach(function(innerKey) {
                    rl[rl.length - 1][key + "_" + innerKey] = (
                      key +
                      " " +
                      innerKey
                    )
                      .replace(/_/g, " ")
                      .split(" ")
                      .map((word) => word[0].toUpperCase() + word.slice(1))
                      .join(" ");
                  });
                  delete rl[rl.length - 1][key];
                } else {
                  if (
                    !blacklist ||
                    !blacklist.length ||
                    blacklist.indexOf(key) == -1
                  ) {
                    rl[rl.length - 1][key] =
                      key == "nama"
                        ? "Nama"
                        : key == "total_per_unit"
                        ? "Jumlah"
                        : key
                            .replace(/_/g, " ")
                            .split(" ")
                            .map(
                              (word) => word[0].toUpperCase() + word.slice(1)
                            )
                            .join(" ");
                  }
                }
              });
            }
            item["no"] = index + 1;
            if ("total" in item) {
              item["jenis_kegiatan"] = "TOTAL";
              item["jumlah"] = item["total"];
              item["no"] = "";
            }
            Object.keys(item).forEach(function(key) {
              if (typeof item[key] == "object") {
                Object.keys(item[key]).forEach(function(innerKey) {
                  item[key + "_" + innerKey] = item[key][innerKey];
                });
                delete item[key];
              } else {
                if (
                  blacklist &&
                  blacklist.length &&
                  blacklist.indexOf(key) > -1
                ) {
                  delete item[key];
                }
              }
            });
            rl.push({ ...item });
          });
          //console.log("-----------rl52");
          //console.log(rl);
          //console.log("-----------rl52");
        } else {
          this.errors.push(result.status);
        }
        this[loadedStr] = true;
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
    },

    apply: async function() {
      //   this.rl51 = [];
      this.displayData(
        this.rl51,
        `rekapitulasi_laporan_5_1?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        "loaded1"
      );
      // this.rl52 = [];
      this.displayDataRl52(
        this.rl52,
        `rekapitulasi_laporan_5_2?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        ["unit"],
        "loaded2"
      );
      this.displayDataRl52(
        this.rl53,
        `rekapitulasi_laporan_5_3?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        ["unit"],
        "loaded3"
      );
      this.displayDataRl52(
        this.rl54,
        `rekapitulasi_laporan_5_4?dari=${this.formSet.dari}&sampai=${this.formSet.sampai}`,
        ["unit"],
        "loaded4"
      );
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    await this.apply();
    // await this.combineData();
  },
};
</script>
